import React, { Component } from "react";
import { Button, Icon } from "@blueprintjs/core";
import { TASK_STATUS, TASK_STATUS_COLOR, PMDNDTypes } from "../../constants";
import IconSmallButton from "../../../blueprintWrappers/IconSmallButton";
import { DragSource } from 'react-dnd';

class AssignedColumnCard extends Component {

	state = {
		minimized: true,
		hover: false,
		expanded: true
	}

	render() {
		const { minimized } = this.state;
		const p = this.props;
		return (
			<div className={p.also ? "AlsoAssignedColumnCard" : "AssignedColumnCard"}>
				{this.header()}
				{!minimized ? this.body() : this.bodyClosed()}
				{p.also ? null : this.footer()}
			</div>
		)
	}

	funcMinimize = () => {
		this.setState({
			minimized: !this.state.minimized
		})
	}

	header = () => {
		const p = this.props;

		const statusStyle = {
			backgroundImage: 'linear-gradient(to right, ' + p.color + ', white)',
		}

		return p.connectDragSource(
			<div className="PMWindowHeader"
				onDoubleClick={this.funcMinimize}
				onMouseEnter={() => this.setState({ hover: true })}
				onMouseLeave={() => this.setState({ hover: false })}>

				{this.state.hover ?

					<div>
						<div className="PMWindowHeaderLeft">
							{p.task.display}
						</div>
						<div className="PMWindowHeaderRight">
							<IconSmallButton iconName={this.state.minimized ? "maximize" : "minimize"} onClick={this.funcMinimize} />
							<div className="PMStatusRound" style={statusStyle} />
						</div>
					</div>

					: /* else */

					<div>
						<div className="PMWindowHeaderLeft">
							{p.task.display}
						</div>
						<div className="PMWindowHeaderRight">
							<div className="PMStatusRound" style={statusStyle} />
						</div>
					</div>

				}
			</div>
		)
	}

	body() {
		const p = this.props;

		if (p.also) {
			return null
		} else {
			return (
				<div className={" pm-uncollapse"}  >
					{p.task.description}
					{this.state.expanded ? this.expanded() : null}
					{p.children}
				</div>
			)
		}

	}

	bodyClosed() {
		const p = this.props;
		if (p.also) {
			return null
		} else {
			return (
				<div className={" pm-uncollapse"} onDoubleClick={this.funcMinimize} >
					{p.task.description}
				</div>
			)
		}
	}

	expanded = () => {
		const p = this.props;
		return <div className="projectmanager_task_list_row_expanded" >

			<div className="projectmanager_task_list_row_item">
				<div>
					<b>General Notes</b>
					{p.task.generalNotes}
				</div>
				<div>
					<b>Dev Notes</b>
					{p.task.devNotes}
				</div>
				<div>
					<b>Lead Notes</b>
					{p.task.leadNotes}
				</div>

			</div>

		</div>
	}

	footer() {
		const p = this.props;
		const { hourLines } = p.task;
		return (
			<div className={"PMTaskFooter"}>
				<div className={"PMTaskGroupLine"}></div>
				<Icon icon="comment" /> {p.task.comments.length}
				Hours: <b>{calcHoursWorked(hourLines)}</b> ({calcHoursBillable(hourLines)} planned)
				<b>{p.task.status}</b>
			</div>
		)

		function calcHoursWorked(hourLines) {
			let total = 0;
			for (let hl of hourLines) {
				total += parseFloat(hl.hours);
			}
			return total;
		}
		function calcHoursBillable(hourLines) {
			let total = 0;
			for (let hl of hourLines) {
				total += parseFloat(hl.billable);
			}
			return total;
		}
	}

}

const dragSource = {
	beginDrag: function (props, monitor, component) {
		return props
	},
	isDragging: function (props, monitor, component) {
	},
	endDrag: function (props, monitor, component) {
	}
}

function dragCollect(connect, monitor, component) {
	return {
		connectDragSource: connect.dragSource(),
		connectDragPreview: connect.dragPreview(),
		isDragging: monitor.isDragging(),
	}
}

AssignedColumnCard = DragSource(PMDNDTypes.WINDOW, dragSource, dragCollect)(AssignedColumnCard);
export default AssignedColumnCard;



// WEBPACK FOOTER //
// ./src/components/projectmanager/new/Assigned/AssignedColumnCard.js